<template>
  <hcm-card
    :resource="resource"
    :cardInfo="'Audio'"
    :cardTitle="resource.title"
    :resourceUrl="'/detail/' + resource.type + '/' + resource.uuid"
    :externalResource="false"
    :cardText="resource.summary"
    :hasSource="true"
    :cardSourceUrl="resource.url"
    :cardSourceAuthor="resource.author"
    :hasShare="true"
    :shareTag="shareTag"
    :shareTitle="shareTitle"
    :shareUrl="shareUrl"
  ></hcm-card>
</template>

<script>
import HCMCard from "./HCMCard.vue";
export default {
  components: { "hcm-card": HCMCard },
  props: {
    resource: {
      type: Object,
      required: true
    }
  },
  computed: {
    shareTag() {
      return "Audio clip";
    },
    shareTitle() {
      return this.resource.title;
    },
    shareUrl() {
      return `${window.location.origin}/detail/AudioItem/${this.resource["uuid"]}`;
    }
  }
};
</script>
